/* eslint-disable radix */
import { handleResponse, handleError } from "./apiUtils";
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';


export async function getCreateTourPreReq(dayTypeId, resourceId, date, userId) {

  let createTourPreReq = await API.graphql(graphqlOperation(queries.tourApIgetCreateTourPreReq,
    {
      dayTypeId,
      resourceId: parseInt(resourceId),
      date,
      userId: parseInt(userId)
    }
  ))

  return createTourPreReq.data.tourAPIgetCreateTourPreReq;
}


export async function createTour(parameters) {

  parameters.IPAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(mutations.tourApIcreateTour, parameters))
    .catch(handleError);

  return response.data.tourAPIcreateTour;
}

export async function deleteTour(tourId, userId) {

  const IPAddress = '27.0.0.1';

  let response = await API.graphql(graphqlOperation(mutations.tourApIdeleteTour, {tourId, userId, IPAddress}))
    .catch(handleError);

  return response.data.tourAPIdeleteTour;
}

export async function updateTour(parameters) {

  parameters.IPAddress = '27.0.0.1';
  // console.log('***** UPDATE TOUR PARAMETERS ******');
  // console.log(parameters); // debug

  let response = await API.graphql(graphqlOperation(mutations.tourApIupdateTour, parameters))
    .catch(handleError);

  return response.data.tourAPIupdateTour;
}

export async function getActiveTours(resourceId, startTime, timeZoneId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetActiveTours,
    {
      resourceId,
      startTime,
      timeZoneId
    }))
    .catch(handleError);

  return response.data.tourAPIgetActiveTours;
}

export async function getDefaultTourLength(relatedServiceId, startTime, resourceId, serviceId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetDefaultTourLength,
    {
      relatedServiceId,
      startTime,
      resourceId,
      serviceId
    }))
    .catch(handleError);

  return response.data.tourAPIgetDefaultTourLength;
}

export async function getTour(parameters) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetTour, parameters))
    .catch(handleError);

  return response.data.tourAPIgetTour;
}

export async function createTourActivityFlag(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.tourApIcreateTourActivityFlag, parameters))
    .catch(handleError);

  return response.data.tourAPIcreateTourActivityFlag;
}

export async function createTourIndicator(parameters) {

  let response = await API.graphql(graphqlOperation(mutations.tourApIcreateTourIndicator, parameters))
    .catch(handleError);

  return response.data.tourAPIcreateTourIndicator;
}

export async function createTourPayTransaction(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.tourApIcreateTourPayTransaction, parameters))
    .catch(handleError);

  return response.data.tourAPIcreateTourPayTransaction;
}

export async function deleteTourActivityFlag(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.tourApIdeleteTourActivityFlag, parameters))
    .catch(handleError);

  return response.data.tourAPIdeleteTourActivityFlag;
}

export async function deleteTourIndicator(tourIndicatorId) {

  let response = await API.graphql(graphqlOperation(mutations.tourApIdeleteTourIndicator, { tourIndicatorId }))
    .catch(handleError);

  return response.data.tourAPIdeleteTourIndicator;
}

export async function deleteTourPayTransaction(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.tourApIdeleteTourPayTransaction, parameters))
    .catch(handleError);

  return response.data.tourAPIdeleteTourPayTransaction;
}

export async function getActivityFlagByTour(tourId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetActivityFlagByTour, { tourId }))
    .catch(handleError);

  return response.data.tourAPIgetActivityFlagByTour;
}

export async function getTourActivityFlags(tourId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetTourActivityFlags, { tourId }))
    .catch(handleError);

  return response.data.tourAPIgetTourActivityFlags;
}

export async function getCodesByIndicator(indicatorId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetCodesByIndicator, { indicatorId }))
    .catch(handleError);
  return response.data.tourAPIgetCodesByIndicator;
}

export async function getIndicatorsById(indicatorId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetIndicatorsById, { indicatorId }))
    .catch(handleError);

  return response.data.tourAPIgetIndicatorsById;
}

export async function getIndicatorsByTour(tourId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetIndicatorsByTour, { tourId }))
    .catch(handleError);

  return response.data.tourAPIgetIndicatorsByTour;
}

export async function getJobElementsByTour(tourId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetJobElementsByTour, { tourId }))
    .catch(handleError);

  return response.data.tourAPIgetJobElementsByTour;
}

export async function getTourMeals(tourId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetTourMeals, { tourId }))
    .catch(handleError);

  return response.data.tourAPIgetTourMeals;
}

export async function getPayTransactionsByTour(tourId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetPayTransactionsByTour, { tourId }))
    .catch(handleError);

  return response.data.tourAPIgetPayTransactionsByTour;
}

export async function getTourActivityFlag(tourActivityFlagId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetTourActivityFlag, { tourActivityFlagId }))
    .catch(handleError);

  return response.data.tourAPIgetTourActivityFlag;
}

export async function getTourIndicator(tourIndicatorId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetTourIndicator, { tourIndicatorId }))
    .catch(handleError);

  return response.data.tourAPIgetTourIndicator;
}

export async function getTourIndicators(tourId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetTourIndicators, { tourId }))
    .catch(handleError);

  return response.data.tourAPIgetTourIndicators;
}

export async function getTourPayTransactions(tourId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetTourPayTransactions, { tourId }))
    .catch(handleError);

  return response.data.tourAPIgetTourPayTransactions;
}

export async function getTourPayTransaction(tourPayTransactionId) {

  let response = await API.graphql(graphqlOperation(queries.tourApIgetTourPayTransaction, { tourPayTransactionId }))
    .catch(handleError);

  return response.data.tourAPIgetTourPayTransaction;
}

export async function updateTourActivityFlag(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.tourApIupdateTourActivityFlag, parameters))
    .catch(handleError);

  return response.data.tourAPIupdateTourActivityFlag;
}

export async function updateTourIndicator(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.tourApIupdateTourIndicator, parameters))
    .catch(handleError);

  return response.data.tourAPIupdateTourIndicator;
}

export async function updateTourPayTransaction(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.tourApIupdateTourPayTransaction, parameters))
    .catch(handleError);

  return response.data.tourAPIupdateTourPayTransaction;
}

export async function getTourExists(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(queries.tourApIgetTourExists, parameters))
    .catch(handleError);

  return response.data.tourAPIgetTourExists;
}

export async function getIfToursAreInDateRange(parameters) {

  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(queries.tourApIgetIfToursAreInDateRange, parameters))
    .catch(handleError);

  return response.data.tourAPIgetIfToursAreInDateRange;
}



// WEBPACK FOOTER //
// ./src/api/tourApi.js